import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { useStyles } from './TakisSkeleton.styles';
import TakisDivider from '../TakisDivider'

const TakisArticleHeroSkeleton = () => {
  const classes = useStyles();
  return (
    <div className={classes.recipeDetailHero}>
      <Skeleton
        className={classes.recipeDetailHeroImage}
      />
      <TakisDivider
        variation={4}
        modifier={classes.recipeDetailHeroDivider}
        backgroundColor="transparent"
        marginModifier={classes.recipeDetailHeroDividerMargin}
      />
    </div>
  );
}

export default TakisArticleHeroSkeleton;
